import React from "react";
import {
  Skeleton,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import { Box, Divider } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";

//styles
import useStyles from "./styles";

const AfterSalesActivityTimelineSkeleton = ({ numberSkeletonCard }) => {
  const styles = useStyles();
  const skeletonCardsAndDate = Array.from(
    { length: numberSkeletonCard },
    (_, index) => (
      <TimelineItem key={index}>
        <TimelineOppositeContent
          className={styles.customTimelineOppositeContent}
        >
          <Skeleton
            animation="wave"
            variant="text"
            className={styles.TimeDateElement}
          />
          <Skeleton
            animation="wave"
            variant="text"
            className={styles.TimeDateElement}
          />
          <Skeleton
            animation="wave"
            variant="text"
            className={styles.TimeDateElement}
          />
        </TimelineOppositeContent>
        <TimelineSeparator className={styles.timelineSeparator}>
          <TimelineDot className={styles.timelineDot} />
          <TimelineConnector className={styles.timelineConnector} />
        </TimelineSeparator>
        <TimelineContent className={styles.customTimelineContent}>
          <CustomCard
            boxShadow="xs"
            borderRadius="xl"
            borderColor="secondary"
            classes={styles.contactActivitesCard}
          >
            <Box className={styles.activityInfoContainer}>
              <Box className={styles.leftSection}>
                <Box className={styles.iconWrapper}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width="40px"
                    height="40px"
                  />
                </Box>
                <Box className={styles.nameStatusContainer}>
                  <Skeleton
                    animation="wave"
                    variant="text"
                    className={styles.titleCard}
                  />
                  <Skeleton
                    style={{ borderRadius: "20px" }}
                    animation="wave"
                    width="64px"
                    height="32px"
                    variant="text"
                  />
                </Box>
              </Box>
              <Box className={styles.rightSection}>
                <Box className={styles.container_Score_CreatedBy_AssignTo}>
                  <Box className={styles.container_CreatedBy_AssignTo}>
                    <Box className={styles.container_CreatedBy}>
                      <Skeleton
                        className={styles.TitleInfo}
                        animation="wave"
                        variant="text"
                      />
                      <Skeleton
                        className={styles.ValueInfo}
                        animation="wave"
                        variant="text"
                      />
                    </Box>
                    <Box className={styles.container_AssignTo_ArrowIcon}>
                      <Skeleton
                        animation="wave"
                        width="24px"
                        height="24px"
                        variant="text"
                      />
                      <Box className={styles.container_AssignTo}>
                        <Skeleton
                          className={styles.TitleInfo}
                          animation="wave"
                          variant="text"
                        />
                        <Skeleton
                          className={styles.ValueInfo}
                          animation="wave"
                          variant="text"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Divider className={styles.divider} />
                <Box className={styles.container_Comment}>
                  <Skeleton
                    animation="wave"
                    className={styles.ValueInfo}
                    variant="text"
                  />
                  <Skeleton
                    animation="wave"
                    className={styles.TitleInfo}
                    variant="text"
                  />
                </Box>
              </Box>
            </Box>
          </CustomCard>
          <Box className={styles.container_MoreIcon}>
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
          </Box>
        </TimelineContent>
      </TimelineItem>
    )
  );
  return (
    <Box className={styles.timelineContainer}>
      <Timeline className={styles.customTimeline}>
        {skeletonCardsAndDate}
      </Timeline>
    </Box>
  );
};

export default AfterSalesActivityTimelineSkeleton;
